import { ModElemModel } from "./ecosat/mod-elem.model";

export class SelectionModel {
    public equipamientoId: number;
    public modelos: ModElemModel[];

    public constructor(equipamientoId: number, modelos: ModElemModel[]) {
        this.equipamientoId = equipamientoId;
        this.modelos = modelos;
    }
}